import closeModal from './close-modal';

export default function(event) {
  if (event.keyCode === 27) {
    closeModal(this);
  }
}
